var map = {
	"./Edit.svg": 1329,
	"./Trash.svg": 5118,
	"./checkmark.svg": 3232,
	"./close.svg": 2273,
	"./copy-regular.svg": 9918,
	"./github.svg": 3987,
	"./instagram.svg": 5311,
	"./star.svg": 3986,
	"./youtube.svg": 4683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2868;